import {
  text,
  textAlt,
  disabledBg,
  brandColor,
  hoverColor,
  grey,
  whiteColor,
} from "../../styles/variables";

import styled from "styled-components";

export const getButtonStyle = ({
  isDisabled,
  isLoading,
  outlineStyle,
  buttonSize,
  marginSize,
}) => {
  let color = whiteColor;
  let backgroundColor = brandColor;
  let hoverBackgroundColor = hoverColor;
  let borderColor = brandColor;

  if (isDisabled) {
    color = textAlt;
    backgroundColor = disabledBg;
    hoverBackgroundColor = disabledBg;
    borderColor = disabledBg;
  }

  if (outlineStyle) {
    color = text;
    backgroundColor = "transparent";
    hoverBackgroundColor = "transparent";
    borderColor = grey;
  }

  return {
    outline: 0,
    border: `1px solid ${borderColor}`,
    display: "block",
    width: buttonSize ? buttonSize : "275px",
    margin: marginSize ? marginSize : "30px 0 20px 0",
    padding: "15px 20px",
    borderRadius: 4,
    fontSize: "14px",
    lineHeight: "1.2em",
    color,
    backgroundColor,
    cursor: isDisabled ? "default" : "pointer",
    transition: "all .3s ease-out",
    pointerEvents: isDisabled || isLoading ? "none" : "auto",
    position: "relative", // handle loader correctly
    minHeight: 46,

    "&:hover, &:focus": {
      backgroundColor: hoverBackgroundColor,
      borderColor: hoverColor,
    },
  };
};

export const StyledButton = styled.button(getButtonStyle);
